goog.provide('el8.appchart.dialog.ordermed.base');

goog.require('el8.appchart.dialog.ordermed.DecisionSupport');
goog.require('el8.appchart.dialog.ordermed.util');
goog.require('el8.appchart.dialog.ordermed.validate');
goog.require('el8.appchart.dialog.ordermed.extractMedData');
goog.require('el8.appchart.permissions');

goog.require('el8.uiwidget.collapsible');
goog.require('el8.uiwidget.LegacyMindreader');
goog.require('el8.uiwidget.NewMindreader');
goog.require('el8.appservice.search');
goog.require('el8.uiwidget.confirm');
goog.require('el8.uiwidget.nonAlarmingAlert');


goog.require('el8.service.tz');
goog.require('el8.appservice.notifier');
goog.require('el8.util.consts');

goog.require('el8.data.referencedPracticians');
goog.require('el8.data.medications');
goog.require('el8.data.practiceUsers');

goog.require('el8.ptdata.medOrders');
goog.require('el8.ptdata.model.med.medOrder');
goog.require('el8.ptdata.medOrderThreads');
goog.require('el8.ptdata.ptProblems');

goog.require('el8.practicedata.medOrderTemplates');

goog.require('el8.template.appchart.dialog.ordermed');
goog.require('el8.template.ptdata.model.medOrderThread');
goog.require('el8.template.mindreader');

goog.require('el8.appchart.dialog.ordermed.selectThread');
goog.require('el8.appchart.dialog.ordermed.qtyDetail');
goog.require('el8.appchart.dialog.ordermed.newMed');



el8.appchart.dialog.ordermed.base = function(spec) {

    /**
     * Form-specific vars
     */
    this._container = spec.container;
    this._actionsMenu = spec.actionsMenu;
    this._isRx = (spec.isRx === true);              // defaults to false
    this._isSamples = (spec.isSamples === true);    // defaults to false
    this._printFormType = spec.printFormType || null;
    this._defaultMedsList = (spec.printFormType === 'otc') ? 'otc' : 'rx';
    this._defaultOrderType = 'New';

    /**
     * Initialize fields
     */
    this._requiredFields = {};
    this._requiredFields['medication'] = spec.medicationField;
    this._requiredFields['directions'] = spec.directionsField;
    this._requiredFields['startDate'] = spec.startDateField; // for post date in rx forms

    // Optional
    this._optFields = {};
    this._optFields['quantity'] = spec.quantityField || null;
    this._optFields['quantityUnits'] = spec.quantityUnitsField || null;
    this._optFields['addToPermanentCheckbox'] = spec.addToPermanentCheckbox || null;
    this._optFields['medsListSelect'] = spec.medsListSelectField;
    this._optFields['indication'] = spec.indicationField;

    this._optFields.dxCodes = spec.dxCodesField || null;
    this._optFields['authRefills'] = spec.authRefillsField || null;
    this._optFields['orderTypeSelect'] = spec.orderTypeSelectField || null;
    this._optFields['prescriber'] = spec.prescriberField || null;
    this._optFields['substitutionsCheckbox'] = spec.substitutionsCheckbox || null;
    this._optFields['pharmacyInstr'] = spec.pharmacyInstrField || null;
    this._optFields['numSamples'] = spec.numSamplesField || null;
    this._optFields['notes'] = spec.notesField || null;
    this._optFields['txStartDate'] = spec.txStartDateField || null;
    this._optFields['oldMed'] = spec.oldMedField || null;
    this._optFields['oldDirections'] = spec.oldDirectionsField || null;

    this._optFields['dcReason'] = spec.dcReasonField || null;
    this._optFields['dcPrescriber'] = spec.dcPrescriberField || null;
    this._optFields['dcDate'] = spec.dcDateField || null;

    this._optDivs = {};
    this._optDivs['relatedThread'] = spec.relatedThreadDiv;
    this._optDivs['relatedThreadInfo'] = $('.meds-related-order-info', spec.relatedThreadDiv);
    this._optDivs['details'] = spec.detailsDiv;
    this._optDivs['detailsTrigger'] = spec.detailsTrigger;

    this._optDivs['patientInfo'] = spec.patientInfoDiv || null;
    this._optDivs['txStartDate'] = spec.txStartDateDiv || null;
    this._optDivs['oldMedInfo'] = spec.oldMedInfoDiv || null;
    this._optDivs['formulary'] = spec.formularyDiv || null;
    this._optDivs['intxns'] = (spec.patientInfoDiv &&
            $('.cds-interactions', spec.patientInfoDiv).length) ?
        $('.cds-interactions', spec.patientInfoDiv) : null;

    this._optDivs['cqmCDS'] = (spec.patientInfoDiv &&
            $('.cqm-cds', spec.patientInfoDiv).length) ?
        $('.cqm-cds', spec.patientInfoDiv) : null;

    this._optDivs['altMed'] = $('.alt-med-indicator', this._container).length ?
        $('.alt-med-indicator', this._container) : null;

    this._optDivs['newMed'] = $('.new-med-indicator', this._container).length ?
        $('.new-med-indicator', this._container) : null;

    this._optDivs['oldMed'] = $('.old-med-indicator', this._container).length ?
        $('.old-med-indicator', this._container) : null;

    this._optDivs['medType'] = $('.medTypeIndicator', this._container).length ?
        $('.medTypeIndicator', this._container) : null;


    /**
     * Reference data
     */
    this.typeHierarchy = {
        'samples': 1,
        'controlled': 2,
        'prescription': 3,
        'otc': 4
    };
    this._NO_RELATED_THREAD_STR = 'Choose existing medication...';

    /**
     * Initialize useful state variables
     */
    this._data = {};
    this._selected = {};
    this._selected['medication'] = null;
    this._selected['newMedicationName'] = null;
    this._selected['newMedicationStrength'] = null;
    this._selected['oldMedication'] = null;
    this._selected['oldMedicationName'] = null;
    this._selected['oldMedicationStrength'] = null;
    this._selected['relatedThreadId'] = null;
    this._selected['qtyPerDay'] = null;

    this._mindreaders = {};
    this._mindreaders['medication'] = null;
    this._mindreaders['qtyUnits'] = null;
    this._mindreaders['indication'] = null;
    this._mindreaders['directions'] = null;
    this._mindreaders['oldMedication'] = null;

    // temp vars to hold sigs from medispan decision support to shared event handling in rxShared
    this._medispanSigs = [];
    this._sigs = [];
    this._medispanSigSourceId = null;
    this._medispanSigSourceType = null; // e.g. "medispanDDID"

    this._physicianSearchField = null;
    this._dcPhysicianSearchField = null;
    this._newMedSaved = false;
    this._oldMedSaved = false;
    this._oldMedFieldIsInit = false;

    this._createDate = null;
    this._userModified = false;

    // triggered when medication has been selected
    this._onMedicationChanged = spec.onMedicationChanged || null;
    this._onCustomMedicationChanged = spec.onCustomMedicationChanged || null;

    /**
     * Initialize decision support
     */
    this._decisionSupport = new el8.appchart.dialog.ordermed.DecisionSupport({
        main: this
    });

    this._templateId = null;
};
el8.appchart.dialog.ordermed.base.prototype.init = function(spec) {
    this.initOrderType();
    this._decisionSupport.initFormulary();
    this._decisionSupport.initCQMCDS();
    this.initMedicationField();
    this.initDxFieldIfItExists();
    this.initIndicationField();
    this.initPrescriberField();
    this.initQtyUnitsField();
    this.initDirectionsField();
    this.initRelatedThreadDiv();
    this.initModifiedListener();
};


// ------------------------
// Managing special divs
// ------------------------
el8.appchart.dialog.ordermed.base.prototype.updateTypeDiv = function(spec) {
    // This serves two functions:
    //  - changing the medsListSelectField to "Rx" or "OTC"
    //  - setting the medTypeDiv to "Rx", "OTC" or "Cntrl'd"
    spec = spec || {};
    var type = spec.type || '';

    if (spec.medication) {
        if (spec.medication.isControlled()) {
            type = 'controlled';
        } else {
            type = spec.medication.getFriendlyType();
        }
    }
    if (this._optDivs['medType']) {
        if (type) {
            this._optDivs['medType'].text(type).show();
        } else {
            this._optDivs['medType'].empty().hide();
        }
    }

    if (this._optFields['medsListSelect']) {
        // If no type, then default medsListSelectField to the default
        if (!type) { type = this._defaultMedsList; }

        this._optFields['medsListSelect']
            .filter('[value="'+type+'"]').prop('checked', true);
    }
};
el8.appchart.dialog.ordermed.base.prototype.initDetailsDiv = function(expandFn,
        collapseFn, initCollapsed) {
    if (!this._optDivs['details'] || !this._optDivs['detailsTrigger']) {
        return;
    }
    el8.uiwidget.collapsible({
        container: this._optDivs['details'],
        triggerElt: this._optDivs['detailsTrigger'],
        statusElt: this._optDivs['detailsTrigger'],
        statusTextCollapse: 'more...',
        statusTextExpand: 'less...',
        collapseFn: collapseFn || null,
        expandFn: expandFn || null,
        isCollapsed: (initCollapsed !== false) // default true
    });
};

// ------------------------
// Managing the orderTypeContainer
// ------------------------
el8.appchart.dialog.ordermed.base.prototype.initOrderType = function() {

    el8.appchart.dialog.ordermed.util.hideDiv(this._optDivs['txStartDate']);
    el8.appchart.dialog.ordermed.util.hideDiv(this._optDivs['oldMedInfo']);

    var that = this;
    if (this._optFields['orderTypeSelect']) {
        this._optFields['orderTypeSelect'].change(function(event) {
            var _type = $(this).val().toLowerCase();
            if (_type === 'new') {
                that.setRelatedThread(null);
                el8.appchart.dialog.ordermed.util.hideDiv(that._optDivs['txStartDate']);
                el8.appchart.dialog.ordermed.util.hideDiv(that._optDivs['oldMedInfo']);
            } else {
                if (!that._selected['relatedThreadId']) {
                    that.setRelatedThread(that._NO_RELATED_THREAD_STR);
                    el8.appchart.dialog.ordermed.util.showDiv(that._optDivs['txStartDate']);
                    if (_type === 'dosechange') {
                        that.showOldMedInfoDiv();
                    }
                } else {
                    el8.appchart.dialog.ordermed.util.hideDiv(that._optDivs['txStartDate']);
                    el8.appchart.dialog.ordermed.util.hideDiv(that._optDivs['oldMedInfo']);
                }
            }
        });
    }
};

// ------------------------
// Data lookup support
// ------------------------
el8.appchart.dialog.ordermed.base.prototype.displayPatientReferenceInfo = function() {
    this._decisionSupport.displayReferenceInfo();
};
el8.appchart.dialog.ordermed.base.prototype.lookupDataSupport = function(successCb) {
    var that = this;
    this._decisionSupport.lookup(function() {
        that._mindreaders['directions'].position();
        if (successCb) { successCb(); }
    });
};
el8.appchart.dialog.ordermed.base.prototype.resetDataSupport = function() {
    this._decisionSupport.reset();
};
el8.appchart.dialog.ordermed.base.prototype.validateCdsInteractions = function(var_args) {
    return this._decisionSupport.validateInteractions.apply(this._decisionSupport, arguments);
};

// --------------------------
// Helper methods for form
// --------------------------
el8.appchart.dialog.ordermed.base.prototype.isEmpty = function() {
    return !this._requiredFields['medication'].getVal();
};
el8.appchart.dialog.ordermed.base.prototype.reset = function() {

    this._selected = {};
    this._data = {};

    if (this._physicianSearchField) { this._physicianSearchField.reset(); }
    if (this._dcPhysicianSearchField) { this._dcPhysicianSearchField.reset(); }
    this.setRelatedThread(null);
    this.updateTypeDiv(null);
    this.resetDataSupport();

    for (var mr in this._mindreaders) {
        if (this._mindreaders.hasOwnProperty(mr) && this._mindreaders[mr]) {
            this._mindreaders[mr].hide();
        }
    }

    this._userModified = false;
    this._templateId = null;
};
el8.appchart.dialog.ordermed.base.prototype.initForms = function() {

    /**
     * Initializes all the fields and sets defaults
     */

    this.resetDataSupport();
    this.displayPatientReferenceInfo();

    // Initialize all fields with instructions
    this._requiredFields['medication'].init();
    this._requiredFields['directions'].init();
    this._requiredFields['startDate'].init();
    if (this._optFields['indication']) { this._optFields['indication'].init(); }
    if (this._optFields['quantity']) { this._optFields['quantity'].init(); }
    if (this._optFields['quantityUnits']) { this._optFields['quantityUnits'].init(); }
    if (this._optFields['authRefills']) { this._optFields['authRefills'].init(); }
    if (this._optFields['prescriber']) { this._optFields['prescriber'].init && this._optFields['prescriber'].init(); }
    if (this._optFields['numSamples']) { this._optFields['numSamples'].init(); }
    if (this._optFields['pharmacyInstr']) { this._optFields['pharmacyInstr'].init(); }
    if (this._optFields['notes']) { this._optFields['notes'].init(); }
    if (this._optFields['txStartDate']) { this._optFields['txStartDate'].init(); }
    if (this._optFields['oldMed']) { this._optFields['oldMed'].init(); }
    if (this._optFields['oldDirections']) { this._optFields['oldDirections'].init(); }

    // Set defaults
    if (this._optFields['orderTypeSelect']) {
        this._optFields['orderTypeSelect'].val(this._defaultOrderType).change();
    }
    if (this._isRx && this._optFields['authRefills']) {
        this._optFields['authRefills'].setVal(0); // default refills to 0 for Rx
    }
    if (!this._isRx && this._optFields['addToPermanentCheckbox']) {
        this._optFields['addToPermanentCheckbox'].prop('checked', 'checked');
    }

    this.updateTypeDiv(null);
    this._requiredFields['startDate'].setVal(el8.service.tz.today().asString());
    if (this._optFields['dcDate']) {
        this._optFields['dcDate'].setVal(el8.service.tz.today().asString());
    }

    if (this._optDivs['newMed']) { this._optDivs['newMed'].empty(); }
    if (this._optDivs['oldMed']) { this._optDivs['oldMed'].empty(); }
    if (this._optDivs['altMed']) { this._optDivs['altMed'].empty(); }

    // If not RX and logged in user is a Physician, default as "Prescribing Physician"
    if (el8.data.currUser.isPhysician()) {
        if (this._physicianSearchField) {
            this._physicianSearchField.setItem({
                id: el8.data.currUser.getStaffId(),
                name: el8.data.currUser.getFullName()
            });
        }
        if (this._dcPhysicianSearchField) {
            this._dcPhysicianSearchField.setItem({
                id: el8.data.currUser.getStaffId(),
                name: el8.data.currUser.getFullName()
            });
        }
    }
};
el8.appchart.dialog.ordermed.base.prototype.populateForms = function(medOrder, noSetType) {

    if (!medOrder) { return; }

    this.prePopulateMedOrder(medOrder);

    if (this._physicianSearchField) {
        if (medOrder.getPrescribingPhysicianId() ||
                medOrder.getPrescribingPhysicianName()) {
            this._physicianSearchField.setItem({
                id: medOrder.getPrescribingPhysicianId(),
                name: medOrder.getPrescribingPhysicianName()
            });
        }
    }
    if (this._data['is_thread_permanent'] && this._optFields['addToPermanentCheckbox']) {
        this._optFields['addToPermanentCheckbox'].prop('checked', true);
    }
    if (!noSetType) {
        // Pre-populate type of order
        var orderType = medOrder.getType() || 'New';
        if (this._optFields['orderTypeSelect']) {
            this._optFields['orderTypeSelect'].val(orderType).change();
        }
    }
    var metadata = medOrder.getMetadata();
    if (metadata) {
        if (metadata.related_thread_id) {
            this.setRelatedThread(metadata.related_thread_id);
        } else {
            if (this._optFields['txStartDate']) {
                this._optFields['txStartDate'].setVal(metadata.tx_start_date || '');
            }
            if (metadata.old_medication_id) {
                this._selected['oldMedication'] =
                    el8.data.medications.getById(metadata.old_medication_id);
            } else {
                this._selected['oldMedicationName'] = metadata.old_medication_name || '';
                this._selected['oldMedicationStrength'] = metadata.old_medication_strength || '';
                if ((this._selected['oldMedicationName'] ||
                        this._selected['oldMedicationStrength']) &&
                        this._optFields['oldMed']) {
                    this._optFields['oldMed'].setVal(
                        el8.appchart.dialog.ordermed.util.displayMed(
                            this._selected['oldMedicationName'],
                            this._selected['oldMedicationStrength']));
                }
                if (this._optFields['oldDirections']) {
                    this._optFields['oldDirections'].setVal(metadata.old_directions || '');
                }
            }
        }
    }
};
el8.appchart.dialog.ordermed.base.prototype.updateForm = function(spec) {

    this.initForms();
    el8.appservice.notifier.notify('Rx form updated with new order');

    spec = spec || {};
    if (!spec.order && !spec.newOrder && !spec.model && !spec.deniedRefillReq) {
        return null;
    }

    var newModel = null;
    if (spec.order) {

        newModel = spec.order.getCopy();
        this._data['is_thread_permanent'] = spec.order.isThreadPermanent();

        var medication = newModel.getMedication();
        if (medication.getPreferredAltId()) {
            newModel.setMedicationId(medication.getPreferredAltId());
            if (this._optDivs['altMed']) {
                this._optDivs['altMed'].html(
                    el8.template.appchart.dialog.ordermed.replacedMed());
            }
        }
        if (medication.getPreferredAltSig()) {
            var directions = newModel.getDirections();
            newModel.setDirections(directions + ' ' + medication.getPreferredAltSig());
        }

        newModel.setType(spec.type || this._defaultOrderType);

        // If model is refill or dose change, don't allow type to be changed
        // again, or else no related order... (can't string match on backend)
        if (newModel.getType().toLowerCase() === 'refill' ||
                newModel.getType().toLowerCase() === 'dosechange') {
            this.setRelatedThread(spec.order.getThreadId());
        } else {
            // Null related order if it's not a refill or dose change, nor a document med
            newModel.setThreadId(null);
            this.setRelatedThread(null);
        }
        if (this._optFields['orderTypeSelect']) {
            this._optFields['orderTypeSelect'].val(newModel.getType()).change();
        }

    } else if (spec.newOrder || spec.model) {
        newModel = spec.newOrder || spec.model;
        if (spec.model) {
            newModel.setType(spec.model.getType() || this._defaultOrderType);
        } else {
            // Won't have spec.model if we're populating from an rx template pseudo-order
            newModel.setType(this._defaultOrderType);
        }

    } else if (spec.deniedRefillReq) {

        // Responding to a refill request with a new rx
        // (technically a denial followed by a new rx)
        newModel = el8.ptdata.model.med.medOrder({
            model_class: 'MedOrder',
            documentDate: el8.service.tz.now(),
            startDate: el8.service.tz.today()
        });
        newModel.setType('New');
        if (spec.denialNote) {
            this._data['denial_note'] = spec.denialNote;
        }
        this._data['refill_request_id'] = spec.deniedRefillReq.getId();
        if (this._optFields['orderTypeSelect']) {
            this._optFields['orderTypeSelect'].val(newModel.getType()).change();
        }
        if (el8Globals.FEATURES.SCRIPTv2017071) {
            // As we are handling a RenewalResponse the script itself counts as one of the refills. Therefore we only
            // want to display the number of additional refills in the form.
            newModel.setAuthRefills(Number(spec.deniedRefillReq._dispensedMedication._requestedRefills) - 1);
        }
    }

    if (newModel) {
        this._selected['medication'] = newModel.getMedication();
        this.populateForms(newModel);
    }

    return newModel;

};
el8.appchart.dialog.ordermed.base.prototype.populatePrescriber = function(physicianId,
        physicianName) {
    var physician = el8.data.referencedPracticians.getById(physicianId);
    if (physician) {
        this._physicianSearchField.setItem({
            id: physicianId,
            name: physicianName || (physician ? physician.getFullName() : '')
        });
    }
};
el8.appchart.dialog.ordermed.base.prototype.prePopulateMedOrder = function(medOrder) {

    this._userModified = true;
    this.prePopulateMedication(medOrder.getMedication());

    var doExpand = false;

    if (medOrder.getStartDate()) {

        /* Expand & populate start date if it's after today */
        if (el8.util.datecompare.isAfterToday(medOrder.getStartDate())) {
            this._requiredFields['startDate'].setVal(medOrder.getStartDate().asString());
            doExpand = true;

        /* Expand (and over-ride start date by keeping as today) if it's in past */
        } else if (!el8.util.datecompare.isToday(medOrder.getStartDate())) {
            doExpand = true;

        } /* Else if today, do nothing */
    }
    this._requiredFields['directions'].setVal(medOrder.getDirections() || '');
    if (this._optFields.dxCodes) {
      this._icd10Listeditor.repopulateFromIdLists({
        icd10Ids: medOrder.getIcd10Ids()
      }, true);
      this.updateDxCodesError();
    }
    if (this._optFields['indication']) {
        if (medOrder.getIndication()) {
            doExpand = true;
            this._optFields['indication'].setVal(medOrder.getIndication());
        }
    }
    if (this._optFields['quantity']) {
        if (medOrder.getQuantity()) {
            if (!this._isRx) { doExpand = true; }
            this._optFields['quantity'].setVal(medOrder.getQuantity());
        }
    }
    if (this._optFields['quantityUnits']) {
        this._optFields['quantityUnits'].setVal(medOrder.getQuantityUnits());
    }
    if (this._optFields['authRefills']) {
        if (medOrder.getAuthRefills() && !this._isRx) { doExpand = true; }
         // used to get getNumAuthRefills() before authRefills became an int and not a string with potentially a qualifier char
        this._optFields['authRefills'].setVal(medOrder.getAuthRefills() || 0);
    }
    if (this._optFields['numSamples']) {
        this._optFields['numSamples'].setVal('');
    }
    if (this._optFields['pharmacyInstr']) {
        if (medOrder.getPharmacyInstructions()) {
            doExpand = true;
            this._optFields['pharmacyInstr'].setVal(medOrder.getPharmacyInstructions());
        }
    }
    if (this._optFields['substitutionsCheckbox']) {
        if (medOrder.isAllowSubstitutions() === false) {  // default is empty (i.e. if null)
            doExpand = true;
            this._optFields['substitutionsCheckbox'].prop('checked', true);
        }
    }
    if (this._optFields['medsListSelect']) {
        if (medOrder.isPrescription()) {
            this._optFields['medsListSelect'].filter('[value="rx"]').prop('checked', true);
        } else {
            this._optFields['medsListSelect'].filter('[value="otc"]').prop('checked', true);
        }
    }
    if (doExpand && this._optDivs['detailsTrigger']) {
        this._optDivs['detailsTrigger'].trigger('el8_expand');
    }

    $.extend(this._data, medOrder.getMetadata() || {});
};
el8.appchart.dialog.ordermed.base.prototype.prePopulateMedication = function(medication) {
    if (!medication) { return; }
    var selectedMedication = this._selected['medication'] = medication;
    this._requiredFields['medication'].setVal(selectedMedication.getDisplayName());
    this._requiredFields['medication'].inputVal = selectedMedication.getDisplayName();
    this.updateTypeDiv({'medication': selectedMedication});
    this.lookupDataSupport();
};
el8.appchart.dialog.ordermed.base.prototype.isEPrescribingControlled = function() {
    return this._printFormType === 'controlled'
        && el8Globals.FEATURES.MDToolboxEPCS
        && el8.data.currUser.isEpcsEnabled();
};

// ------------------------
// Get med from form
// ------------------------
el8.appchart.dialog.ordermed.base.prototype.getMedOrder = function(model, isSignedOff) {
    return el8.appchart.dialog.ordermed.extractMedData(this, model, isSignedOff);
};
el8.appchart.dialog.ordermed.base.prototype.getDcPhysicianSearchField = function() {
    return this._dcPhysicianSearchField;
};

// ------------------------
// Manage related order div
// ------------------------
el8.appchart.dialog.ordermed.base.prototype.initRelatedThreadDiv = function() {

    if (!this._optDivs['relatedThreadInfo']) { return; }

    var that = this;
    var menu = [];
    menu.push({
        actionText: "Med To Link To...",
        actionFn: function() {
            that.showSelectRelatedThread();
        }
    });
    menu.push({
        actionText: "No Med To Link To",
        actionFn: function() {
            that.clearRelatedThread();
        }
    });

    this._optDivs['relatedThreadInfo'].on('click', function(event) {
        that._actionsMenu.display($(this), null, null, menu);
        return false;
    });
};
el8.appchart.dialog.ordermed.base.prototype.setRelatedThread = function(threadId, doPopulate) {

    var that = this;

    function _updateDivs() {

        var orderTypeSelectField = that._optFields['orderTypeSelect'];
        var oldMedInfoDiv = that._optDivs['oldMedInfo'];
        var txStartDateDiv = that._optDivs['txStartDate'];
        var orderType = orderTypeSelectField && orderTypeSelectField.val() ?
            orderTypeSelectField.val().toLowerCase() : '';

        if (txStartDateDiv && oldMedInfoDiv) {
            if (orderType === 'refill') {
                el8.appchart.dialog.ordermed.util.hideDiv(oldMedInfoDiv);
                if (that._selected['relatedThreadId']) {
                    el8.appchart.dialog.ordermed.util.hideDiv(txStartDateDiv);
                } else {
                    el8.appchart.dialog.ordermed.util.showDiv(txStartDateDiv);
                }
            } else if (orderType === 'dosechange') {
                if (that._selected['relatedThreadId']) {
                    el8.appchart.dialog.ordermed.util.hideDiv(txStartDateDiv);
                    el8.appchart.dialog.ordermed.util.hideDiv(oldMedInfoDiv);
                } else {
                    el8.appchart.dialog.ordermed.util.showDiv(txStartDateDiv);
                    that.showOldMedInfoDiv();
                }
            } else {
                el8.appchart.dialog.ordermed.util.hideDiv(txStartDateDiv);
                el8.appchart.dialog.ordermed.util.hideDiv(oldMedInfoDiv);
            }
        }
    }

    var thread = null;
    var relatedThreadDiv = this._optDivs['relatedThread'];
    var relatedThreadInfoDiv = this._optDivs['relatedThreadInfo'];

    // If null, we hide
    if (threadId === null) {
        if (relatedThreadDiv) { relatedThreadDiv.hide(); }
        if (relatedThreadInfoDiv) { relatedThreadInfoDiv.empty(); }
        this._selected['relatedThreadId'] = null;

    // If we get a thread...
    } else if (!isNaN(threadId)) {
        if (relatedThreadDiv) { relatedThreadDiv.show(); }
        thread = el8.ptdata.medOrderThreads.getById(threadId, false);
        if (thread) {
            if (relatedThreadInfoDiv) {
                relatedThreadInfoDiv.html(
                    el8.template.ptdata.model.medOrderThread.summary(thread.asSoyMap()));
            }
            this._selected['relatedThreadId'] = threadId;

            if (thread.isControlled()) {
              var orderTypeSelectField = that._optFields['orderTypeSelect'];
              var orderType = orderTypeSelectField && orderTypeSelectField.val() || '';
              // Check to see if this is the appropriate form
              that._checkPrintFormType(thread.getLatestOrder().getMedication(), {
                type: orderType,
                order: thread.getLatestOrder()
              });
            }
        } else {
            // this thread has been deleted - clear it
            this.clearRelatedThread();
            return;
        }

    // If we get a string to display...
    } else if (typeof(threadId) === 'string') {
        if (relatedThreadDiv) { relatedThreadDiv.show(); }
        if (relatedThreadInfoDiv) { relatedThreadInfoDiv.text(threadId); }
        this._selected['relatedThreadId'] = null;
    }

    _updateDivs();

    if (doPopulate && thread && this.isEmpty()) {
        this.prePopulateMedOrder(thread.getLatestMedOrder());
        if (this._optFields['quantity']) {
            this._optFields['quantity'].getInputField().focusSelect();
        }
    }

};
el8.appchart.dialog.ordermed.base.prototype.clearRelatedThread = function() {
    this.setRelatedThread(this._NO_RELATED_THREAD_STR);
};
el8.appchart.dialog.ordermed.base.prototype.showSelectRelatedThread = function() {
    var that = this;
    el8.appchart.dialog.ordermed.selectThread.show(
        true,
        function(threadId) {
            that.setRelatedThread(threadId, true);
        }
    );
};

// -------------------------
// Perform validation
//
// saveFn is used if the validator halts saving but wants to allow automatic
// resumption (e.g., when asking a staff member for a missing prescribingPhysicianId)
// -------------------------
el8.appchart.dialog.ordermed.base.prototype.validate = function(medOrder, isEPrescribe, saveFn) {
    return el8.appchart.dialog.ordermed.validate(this, medOrder, isEPrescribe, saveFn);
};
el8.appchart.dialog.ordermed.base.prototype.validateDraft = function(medOrder, isEPrescribe) {
    return el8.appchart.dialog.ordermed.validateDraft(this, medOrder, isEPrescribe);
};

// ----------------------
// Initialize specific fields
// ----------------------
el8.appchart.dialog.ordermed.base.prototype.initIndicationField = function() {
    var indicationField = this._optFields['indication'];
    if (indicationField) {
        this._mindreaders['indication'] = (new el8.uiwidget.LegacyMindreader({
            data: el8.ptdata.ptProblems.all().map(function(a) { return a.getDescription(); })
        })).init(indicationField.getInputField());
    }
};
el8.appchart.dialog.ordermed.base.prototype.initPrescriberField = function() {
    if (this._optFields['prescriber']) {
        var that = this;
        this._physicianSearchField = (new el8.uiwidget.ClickItem(
            el8.app.shared.clickItemOpts.physicians({
                newContactCb: function(contact) {
                    if (!contact) { return; }
                    that._physicianSearchField.setItem({
                        id: contact.getId(),
                        name: contact.getFullName()
                    });
                }
            })
        )).init({elt: this._optFields['prescriber']});
    }
    if (this._optFields['dcPrescriber']) {
        var that = this;
        this._dcPhysicianSearchField = (new el8.uiwidget.ClickItem(
            el8.app.shared.clickItemOpts.physicians({
                newContactCb: function(contact) {
                    if (!contact) { return; }
                    that._dcPhysicianSearchField.setItem({
                        id: contact.getId(),
                        name: contact.getFullName()
                    });
                }
            })
        )).init({elt: this._optFields['dcPrescriber']});
    }
};
el8.appchart.dialog.ordermed.base.prototype.initQtyUnitsField = function() {

    if (!this._optFields['quantityUnits']) { return; }

    var data = el8.util.consts.MED_ORDER_QUANTITY_DISPLAY_UNITS;
    if (this._printFormType === 'controlled') {
        if (el8Globals.FEATURES.NewSurescriptsEPCS) {
            data = el8.util.consts.SURESCRIPTS_ALLOWED_QUANTITY_UNITS;
        } else {
            data = el8.util.consts.MED_ORDER_QUANTITY_DISPLAY_UNITS_EPCS;
        }
    }

    this._mindreaders['qtyUnits'] = (new el8.uiwidget.NewMindreader({
        data: data,
        ignoreStr: this._optFields['quantityUnits'].getInfoText(),
        minQueryLength: 1
    })).init(this._optFields['quantityUnits'].getInputField());

    var that = this;
    this._optFields['quantityUnits'].getInputField().blur(function(e) {
        var val = that._optFields['quantityUnits'].getVal();
        if ((val.toLowerCase() === 'days' ||
             val.toLowerCase() === 'day') && !that._selected['qtyPerDay']) {
            el8.appchart.dialog.ordermed.qtyDetail.show(
                function(val) { that._selected['qtyPerDay'] = val; },
                function() { that._optFields['quantityUnits'].setVal(''); }
            );
        }
        return false;
    });
};
el8.appchart.dialog.ordermed.base.prototype.initDirectionsField = function() {
    var that = this;

    // when "Create a custom sig" entry in the MR is clicked
    var actionFn = _.bind(function(val) {
        if (!val) {
            el8.uiwidget.nonAlarmingAlert('Please enter the custom sig text.');
            return false;
        } else {
            if (!that._medispanSigs.find(function(sig){ return sig === val; }) &&
                !that._sigs.find(function(sig){ return sig === val; }) &&
                val &&
                val !== 'sig...' &&
                that._medispanSigSourceId &&
                that._medispanSigSourceType) {

                el8.appchart.dialog.addRxSig.show({
                    name: that._requiredFields['medication'].getVal(),
                    directions:  val,
                    sourceId: that._medispanSigSourceId,
                    sourceType: that._medispanSigSourceType
                });
            }
        }
    }, that);

    this._mindreaders['directions'] = (new el8.uiwidget.NewMindreader({
        data: [],
        formatResult: function(item) {
            return el8.template.mindreader.rxSig({item: item});
        },
        formatSelected: function(item) { return item.sig; },
        rowToStringFn: function(item) { return item.sig; },
        ignoreStr: this._requiredFields['directions'].getInfoText(),
        minQueryLength: 1,
        showOnFocus: true,
        actions: [
            {
                name: 'Create a custom sig for this med...',
                actionFn: actionFn,
                preserveValOnClick: true
            }
        ]

    })).init(this._requiredFields['directions'].getInputField());
};

el8.appchart.dialog.ordermed.base.prototype.hasDxField = function() {
  return Boolean(this._optFields.dxCodes);
}

el8.appchart.dialog.ordermed.base.prototype.initDxFieldIfItExists = function() {
  if (!this.hasDxField()) return;

  var that = this;
  this._icd10Listeditor = (new el8.uiwidget.Icd10ListEditor({
    listContainer: this._optFields.dxCodes,
    onImoSelectFn: function (icd10Le, item) {
      if (item.imo_code) {
          var imo = el8.data.imos.getByKey(item.imo_code);
          imo.getAsBillDxMaps().forEach(function(dxMap) {
              icd10Le.addNewEntry(dxMap);
          });
      } else if (item.model_class === 'ICD10Code') {
          var icd10 = el8.data.icd10Codes.create(item);
          icd10Le.addNewEntry({
              icd10Code: icd10.asSoyMap()
          });
      }
    },
    onAddEntry: function() {
      that.updateDxCodesError();
    },
    onRemoveEntry: function() {
      that.updateDxCodesError();
    },
    index: null // only one LE
  })).init();
}

/**
 * Updates the inline error shown for the ICD-10 list editor, depending on how
 * many items are currently in the list.
 */
el8.appchart.dialog.ordermed.base.prototype.updateDxCodesError = function() {
  if (!this.hasDxField()) return;

  var codeCount = this._icd10Listeditor.getEntryCount();
  var errorHtml = '';
  if (codeCount > 1 && this.isEPrescribingControlled()) {
      errorHtml = '<div class="padb5">Too many Dx codes: Select up to 1 Dx code to send to the pharmacy for controlled substances</div>';
  }
  else if (codeCount > 2) {
      errorHtml = '<div class="padb5">Too many Dx codes: Select up to 2 Dx codes to send to the pharmacy</div>';
  }
  $('.dx-codes-error', this._optFields.dxCodes.parent()).html(errorHtml);
}

// ----------------------
// Initialize medication fields
// ----------------------
el8.appchart.dialog.ordermed.base.prototype.initMedicationField = function() {

    var medicationField = this._requiredFields['medication'];
    medicationField.inputVal = null;

    var that = this;
    this._mindreaders['medication'] = this._initMedicationInput({
        field: this._requiredFields['medication'],
        selected: this._selected['medication'],
        resultFn: function(item) {
            that._selected['medication'] = el8.data.medications.create(item);
            medicationField.inputVal = medicationField.getVal();

            // Check to see if this is the appropriate form
            that._checkPrintFormType(that._selected['medication']);

            // Get formulary and cds information
            that.lookupDataSupport();

            // Reset these in case of new med being selected
            that._newMedSaved = false; // reset this
            that._selected['newMedicationName'] = null;
            that._selected['newMedicationStrength'] = null;

            // If medication is created by user, then allow changing of medication details
            //updateTypeContainer();
            // If old med info div is showing and empty, update it
            // TODO Not updating for now because autocomplete is wonky
            //if (oldMedInfoDiv.is(":visible") && oldMedField.getVal() === '') {
            //    selectedOldMedication = selectedMedication;
            //    oldMedField.setVal(medicationField.getVal());
            //    oldMedField.hasMatch = true;
            //}

            if (that._onMedicationChanged) {
                that._onMedicationChanged(that._selected['medication']);
            }
        },
        newMedFn: function(spec) {

            that._newMedSaved = true;
            that._selected['newMedicationName'] = spec.brandName.trim();
            that._selected['newMedicationStrength'] = spec.strength.trim();
            var newMedicationType = spec.medType;

            medicationField.setVal(
                el8.appchart.dialog.ordermed.util.displayMed(
                    that._selected['newMedicationName'],
                    that._selected['newMedicationStrength']));
            that._requiredFields['directions'].getInputField().focusSelect();
            that.updateTypeDiv({'type': newMedicationType});

            // reset these
            that._selected['medication'] = null;
            medicationField.inputVal = null;

            if (that._onCustomMedicationChanged) {
                that._onCustomMedicationChanged(spec);
            }
        },
        onChangeFn: function() {
            if (that._selected['medication']) {
                if (medicationField.getVal() !== medicationField.inputVal) {
                    that._selected['medication'] = null;
                    that.updateTypeDiv(null);
                    // Always empty this div if medication is changed
                    if (that._optDivs['altMed']) {
                        that._optDivs['altMed'].empty();
                    }
                    that.resetDataSupport();
                }
            } else if (that._newMedSaved) {
                // Always empty this div if medication is changed
                if (that._optDivs['altMed']) {
                    that._optDivs['altMed'].empty();
                }
                that.resetDataSupport();
                if (medicationField.getVal() !==
                        el8.appchart.dialog.ordermed.util.displayMed(
                            that._selected['newMedicationName'],
                            that._selected['newMedicationStrength'])) {
                    that._newMedSaved = false; // reset this
                    that._selected['newMedicationName'] = null;
                    that._selected['newMedicationStrength'] = null;
                    that.updateTypeDiv(null);
                }
            } else {
                // Always empty this div if medication is changed
                if (that._optDivs['altMed']) {
                    that._optDivs['altMed'].empty();
                }
                that.resetDataSupport();
                that.updateTypeDiv(null);
            }
        },
        unknownMedCondn: function() {
            return (!that._selected['medication'] && !that.isEmpty() && !that._newMedSaved);
        },
        medDiv: that._optDivs['newMed']
    });
};
el8.appchart.dialog.ordermed.base.prototype.initOldMedField = function() {

    // TODO Not updating for now because autocomplete is wonky
    //oldMedField.setVal(medicationField.getVal());
    //selectedOldMedication = selectedMedication;
    //if (selectedOldMedication) { medicationField.hasMatch = true; }
    //oldDirectionsField.setVal(directionsField.getVal());

    if (!this._optFields['oldMed'] || this._oldMedFieldIsInit) { return; }

    var oldMedField = this._optFields['oldMed'];
    var oldDirectionsField = this._optFields['oldDirections'];
    oldMedField.inputVal = null;

    var that = this;
    this._mindreaders['oldMedication'] = this._initMedicationInput({
        field: oldMedField,
        selected: this._selected['oldMedication'],
        resultFn: function(item) {
            that._selected['oldMedication'] = el8.data.medications.create(item);
            oldMedField.inputVal = that._requiredFields['medication'].getVal();

            // Reset these in case of new med being selected
            that._oldMedSaved = false;
            that._selected['oldMedicationName'] = null;
            that._selected['oldMedicationStrength'] = null;
        },
        newMedFn: function(spec) {

            that._oldMedSaved = true;
            that._selected['oldMedicationName'] = spec.brandName.trim();
            that._selected['oldMedicationStrength'] = spec.strength.trim();

            oldMedField.setVal(
                el8.appchart.dialog.ordermed.util.displayMed(
                    that._selected['oldMedicationName'],
                    that._selected['oldMedicationStrength']));
            if (oldDirectionsField) {
                oldDirectionsField.getInputField().focusSelect();
            }

            that._selected['oldMedicationName'] = null;
            oldMedField.inputVal = null; // reset this
        },
        onChangeFn: function() {
            if (that._selected['oldMedication']) {
                if (oldMedField.getVal() !== oldMedField.inputVal) {
                    that._selected['oldMedication'] = null;
                }
            } else if (that._oldMedSaved) {
                if (oldMedField.getVal() !==
                        el8.appchart.dialog.ordermed.util.displayMed(
                            that._selected['oldMedicationName'],
                            that._selected['oldMedicationStrength'])) {
                    that._oldMedSaved = false;
                    that._selected['oldMedicationName'] = null;
                    that._selected['oldMedicationStrength'] = null;
                }
            }
        },
        unknownMedCondn: function() {
            return (!that._selected['oldMedication'] &&
                oldMedField.getVal() !== '' && !that._oldMedSaved);
        },
        medDiv: that._optDivs['oldMed']
    });

    this._oldMedFieldIsInit = true;
};
el8.appchart.dialog.ordermed.base.prototype.showOldMedInfoDiv = function() {
    el8.appchart.dialog.ordermed.util.showDiv(this._optDivs['oldMedInfo']);
    this.initOldMedField();
};

// ----------------------
// Helpers for medication input fields
// ----------------------
el8.appchart.dialog.ordermed.base.prototype._initMedicationInput = function(spec) {

    var medSearchUrl = '/s/search/medications/';
    var currentPatientId = el8.ptdata.currPatient.getId();
    if (currentPatientId) {
        medSearchUrl = '/s/search/patient/' + currentPatientId + '/medications/';
    }

    var that = this;
    var medMindreader = new el8.uiwidget.NewMindreader({
        url: medSearchUrl,
        limit: 200,
        newMindreader: true,
        entryHeight: 50,
        urlParams: el8Globals.FEATURES.MedOrderTemplates ? {'med_order_templates': 1, 'med_type': this._printFormType} : {'med_type': this._printFormType},
        containerWidth: 560,
        selectFn: function(event, item) {
            // We need to populate the fields if the item is a med order template
            if (item.name) { // Only med order templates have item.name
                // map items
                var med = el8.practicedata.medOrderTemplates.create(item).asSoyMap();
                that._requiredFields['directions'].setVal(med.directions);
                // some dialogs do not have these fields, so we should only set
                // values for fields that exist.
                if (that._optFields['quantity']) {
                    that._optFields['quantity'].setVal(med.qty);
                    that._optFields['quantityUnits'].setVal(med.qtyUnits);
                }
                if (that._optFields['authRefills']) {
                    that._optFields['authRefills'].setVal(med.authRefills);
                }
                // Due to the fact we check for drug interactions, the item
                // needs to be passed as a medication again to allow for resultFn
                // to work correctly.
                item = el8.data.medications.getById(med.medicationId).asSoyMap();

                // attach the templateId to the form
                if (med.id) { that._templateId = med.id; }
            }
            spec.resultFn(item);
            spec.medDiv.empty().hide();

            // figuring out if we need to flip federal controlled state
            // based on what's in controlled_exception_states array
            var isControlled = (item.isControlled || item.is_controlled);
            var currentState = el8.data.currPractice.getState();

            if (item.controlled_exception_states &&
                _.contains(item.controlled_exception_states, currentState)) {
                isControlled = true;
            }

            var type;
            if (isControlled) {
                type = 'controlled';
            } else {
                if (item.type === 'prescription') { type = 'rx'; }
                else if (item.type === 'otc') { type = 'otc'; }
                else { type = null; }
            }
            that.updateTypeDiv({type: type});
        },
        formatResult: function(item) {
            if (item.name) { // if we have an item.name, then it's a medication template, and we map it so
                var med = el8.practicedata.medOrderTemplates.create(item);
                return el8.template.mindreader.medication({item: med.asSoyMap()});
            }
            else { // if not, we used to leave it, but now we just populate it as medication
                // since we need to have the medication object to properly handle state specific
                // drug schedule override and don't want to replicate that logic all over the place
                var med = el8.data.medications.create(item);
                return el8.template.mindreader.medication({item: med.asSoyMap()});
            }
        },
        formatSelected: function(item) {
            var result;
            if (item.name) {
                result = item.name;
            } else {
                result = item.clean_name;
            }
            return result;
        },
        actions: el8Globals.FEATURES.MedOrderTemplates ? [{
            name: 'Manage Rx Templates...',
            actionFn: function() { window.open('/settings/prescriptions/'); }
        }] : null
    }).init(spec.field.getInputField());

    // Initialize new med div
    spec.medDiv.empty().hide();

    spec.field.getInputField().on('blur', function(e) {
        spec.onChangeFn();
        if (spec.unknownMedCondn()) {
            spec.medDiv.show().html(
                el8.template.appchart.dialog.ordermed.unknownMed()
            );
            if (that.adjustHeight) { that.adjustHeight(); }

            var promptNewMedFn = function() {
                var _inputStr = spec.field.getVal();
                var _strengthIndex = _inputStr.search(/\s+[0-9]+/);
                var _brandName = (_strengthIndex === -1) ? _inputStr : _inputStr.substring(0,_strengthIndex);
                var _strength = (_strengthIndex === -1) ? '' : _inputStr.substring(_strengthIndex);
                el8.appchart.dialog.ordermed.newMed.show(
                    {
                        brandName: _brandName,
                        strength: _strength
                    },
                    function(_spec) {
                        spec.newMedFn(_spec);
                        spec.medDiv.empty().hide();
                    }
                );
            };
            spec.medDiv.find('a').on('click', promptNewMedFn);
        }
    });

    return medMindreader;
};
el8.appchart.dialog.ordermed.base.prototype._checkPrintFormType = function(medication, spec) {
    if (this._printFormType) {
        var that = this;

        if (medication.isControlled() && this._printFormType !== 'controlled') {
            el8.uiwidget.confirm(
                'Controlled substances must be ordered using the Controlled Substance form to be accepted by the pharmacy. If you choose to continue anyway, you will not be permitted to ePrescribe.',
                function() {
                    var model = that.getMedOrder(null, false);
                    that.closeIfNoQueue();
                    var formSpec = _.extend({}, spec, { model: model });
                    el8.appchart.mgr.orderForm.showMedsOrderForm(false, formSpec, 'controlled');
                },
                function() {
                    that._requiredFields['medication'].getInputField().focusSelect();
                },
                { yesBtnText: 'Use Controlled Substance Form',
                  noBtnText: 'Continue anyway',
                  prefWidth: '520' }
            );
            return;

        } else if (medication.isPrescription() && this._printFormType !== 'controlled' &&
                 this._printFormType !== 'prescription') {
            el8.uiwidget.confirm(
                'Prescriptions must be ordered using the Prescription Form to be accepted by the pharmacy. If you choose to continue anyway, you will not be permitted to ePrescribe.',
                function() {
                    var model = that.getMedOrder(null, false);
                    that.closeIfNoQueue();
                    el8.appchart.mgr.orderForm.showMedsOrderForm(false, {
                        model: model
                    }, 'prescription');
                },
                function() {
                    that._requiredFields['directions'].getInputField().focusFocus();
                },
                { yesBtnText: 'Use Prescription Form',
                  noBtnText: 'Continue anyway',
                  prefWidth: '520' }
            );
        }
    }
};

// ----------------------
// Listener for whether the form has been modified
// ----------------------
el8.appchart.dialog.ordermed.base.prototype.initModifiedListener = function() {
    var that = this;
    this._container.on('keydown', ':input[type="text"]',  function() {
        // This is not an accurate measure of whether the form is "dirty"
        // but it's not terrible for a cheap solution
        that._userModified = true;
    });
};
